export class TaskReward {
    public readonly points: number;
    public readonly getChance: number;
    public readonly multiplierChance: number;
    public readonly multiplier: number;
    public readonly nothingChance: number;
    public readonly removeChance: number;
    public readonly removeMultiplierChance: number;
    public readonly removeMultiplier: number;

    static createGuaranteed(points: number) {
        return new TaskReward(
            points,
            1, // getChance
            0, // multiplierChance
            1, // multiplier
            0, // nothingChance
            0, // removeChance
            0, // removeMultiplierChance
            1  // removeMultiplier
        );
    }

    static createChance(points: number, getChance: number, multiplierChance: number, multiplier: number, nothingChance: number, removeChance: number, removeMultiplierChance: number, removeMultiplier: number) {
        return new TaskReward(
            points,
            getChance,
            multiplierChance,
            multiplier,
            nothingChance,
            removeChance,
            removeMultiplierChance,
            removeMultiplier
        );
    }

    static copyWith(old: TaskReward, overrides: Partial<TaskReward>): TaskReward {
        return new TaskReward(
            overrides.points ?? old.points,
            overrides.getChance ?? old.getChance,
            overrides.multiplierChance ?? old.multiplierChance,
            overrides.multiplier ?? old.multiplier,
            overrides.nothingChance ?? old.nothingChance,
            overrides.removeChance ?? old.removeChance,
            overrides.removeMultiplierChance ?? old.removeMultiplierChance,
            overrides.removeMultiplier ?? old.removeMultiplier
        );
    }

    constructor(points: number, getChance: number, multiplierChance: number, multiplier: number, nothingChance: number, removeChance: number, removeMultiplierChance: number, removeMultiplier: number) {
        this.points = points;
        this.getChance = getChance;
        this.multiplierChance = multiplierChance;
        this.multiplier = multiplier;
        this.nothingChance = nothingChance;
        this.removeChance = removeChance;
        this.removeMultiplierChance = removeMultiplierChance;
        this.removeMultiplier = removeMultiplier;
    }
}